export default {
    getRecentNews(state){
        return state.recentNews
    }
}